/* ============================================================
   Hero Section — behavior
   - If GSAP is available (loaded via CDN in the section), it
     drives a smoother staggered "rise from bottom" load-in and
     continuous floating for each image block. If GSAP fails to
     load (blocked, offline CDN, etc.), CSS handles both as a
     fallback (see hero.css).
   - Looping typewriter effect on the last heading word runs
     independently of GSAP (plain JS).
   - Re-initializes on Shopify's shopify:section:load so editing
     settings in the theme editor doesn't leave it inert.
   ============================================================ */

function initAllHeroes(root) {
  var scope = root || document;
  scope.querySelectorAll('[data-hero-section]').forEach(function (hero) {
    if (hero.dataset.heroInit === 'true') return;
    hero.dataset.heroInit = 'true';
    initHero(hero);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initAllHeroes();
  });
} else {
  initAllHeroes();
}

document.addEventListener('shopify:section:load', function (event) {
  initAllHeroes(event.target);
});

function initHero(hero) {
  var gsapReady = typeof window.gsap !== 'undefined';
  var wantsLoadAnimation = hero.dataset.loadAnimation === 'true';
  var eyebrowEl = hero.querySelector('.hero-eyebrow');
  var wordEls = hero.querySelectorAll('[data-hero-word]');
  var floatEls = hero.querySelectorAll('[data-float]');

  if (gsapReady) {
    // GSAP takes over floating — remove the CSS animation so they don't fight
    floatEls.forEach(function (el) {
      el.classList.remove('is-floating');
      var dist = parseFloat(el.dataset.floatDistance) || 14;
      var dur = parseFloat(el.dataset.floatDuration) || 3.5;
      var delay = parseFloat(el.dataset.floatDelay) || 0;
      var rotate = parseFloat(el.dataset.rotate) || 0;

      window.gsap.to(el, {
        y: '+=' + dist,
        rotation: rotate + (Math.random() > 0.5 ? 3 : -3),
        duration: dur,
        delay: delay,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut'
      });
    });

    if (wantsLoadAnimation) {
      var tl = window.gsap.timeline({ defaults: { ease: 'power3.out' } });

      if (eyebrowEl) {
        tl.fromTo(eyebrowEl, { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7 }, 0.1);
      }

      if (wordEls.length) {
        tl.fromTo(
          wordEls,
          { y: '120%', opacity: 0 },
          { y: '0%', opacity: 1, duration: 0.7, stagger: 0.055 },
          0.25
        );
      }
    }
  } else if (wantsLoadAnimation) {
    // CSS fallback: stagger each word's animation-delay, then trigger
    // the keyframe animations defined in hero.css via the is-visible class
    wordEls.forEach(function (el, i) {
      el.style.animationDelay = 0.25 + i * 0.055 + 's';
    });
    window.requestAnimationFrame(function () {
      hero.classList.add('is-visible');
    });
  } else {
    hero.classList.add('is-visible');
  }

  /* ---------- Looping typewriter on the last heading word ---------- */
  var typewriterEl = hero.querySelector('[data-typewriter]');
  if (typewriterEl) {
    var word = typewriterEl.textContent.trim();
    var i = word.length;
    var deleting = false;
    var typeSpeed = 110;
    var deleteSpeed = 60;
    var holdFull = 1600;
    var holdEmpty = 400;

    function tick() {
      if (!deleting) {
        i++;
        typewriterEl.textContent = word.slice(0, i);
        if (i >= word.length) {
          deleting = true;
          window.setTimeout(tick, holdFull);
          return;
        }
      } else {
        i--;
        typewriterEl.textContent = word.slice(0, i);
        if (i <= 0) {
          deleting = false;
          window.setTimeout(tick, holdEmpty);
          return;
        }
      }
      window.setTimeout(tick, deleting ? deleteSpeed : typeSpeed);
    }

    // Start the loop after the initial load-in settles
    window.setTimeout(tick, 1400);
  }
}